import script from "./StoreSetup.vue?vue&type=script&setup=true&lang=js"
export * from "./StoreSetup.vue?vue&type=script&setup=true&lang=js"

import "./StoreSetup.vue?vue&type=style&index=0&id=54af3fdc&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54af3fdc"]])

export default __exports__